const polygonOptions = {
  strokeColor: "yellow",
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: "rgba(255, 255, 0, 0.08)",
  fillOpacity: 1,
};

export { polygonOptions };
